import CategoryPage from '@/routes/crane/category_page.vue'
import ProductPage from '@/routes/crane/product_page.vue'
import BuilderioPage from '@/routes/crane/builderio_page.vue'

let seoRoutes = window.seoRoutes ? window.seoRoutes({ cp: CategoryPage, pp: ProductPage }) : []

let seoUrls = window.urlRewrites ? window.urlRewrites : []

const vueHomePageUrl = import.meta.env.VITE_HOME_PAGE_URL
const useStripePayment = import.meta.env.VITE_USE_STRIPE_PAYMENT
let defaultRoutes = [
    {
        path: '',
        name: 'HomePage',
        component: () => import(/* webpackChunkName: "craneMain" */ '@/routes/crane/home_page.vue'),
        meta: {
            breadcrumb: {
                label: 'Home',
            },
        },
    },
    {
        path: 'search',
        name: 'SearchPage',
        component: () =>
            import(/* webpackChunkName: "craneMain" */ '@/routes/crane/search_page.vue'),
        meta: {
            breadcrumb: {
                label: 'SearchPage Page',
            },
        },
    },
    {
        path: 'shortcuts',
        name: 'shortcutsPage',
        component: () =>
            import(/* webpackChunkName: "craneMain" */ '@/routes/crane/shortcuts_page.vue'),
        meta: {
            canonical: true,
            breadcrumb: {
                label: 'shortcuts Page',
            },
        },
    },

    {
        path: 'crane-connection/:retailorId/:quantity/:itemNumber/:ccid?/:savItemId?',
        name: 'CraneConnection',
        component: () =>
            import(/* webpackChunkName: "craneMain" */ '@/routes/crane/crane_connection.vue'),
        meta: {
            breadcrumb: {
                label: 'Crane Connection',
            },
        },
    },

    {
        path: 'logout-success',
        name: 'LogOutSuccess',
        component: () =>
            import(/* webpackChunkName: "craneMain" */ '@/routes/crane/logout_success.vue'),
        meta: {
            breadcrumb: {
                label: 'LogOut Success',
            },
        },
    },
    {
        path: 'cc-action/:ccid/:mode/:quantity/:itemNumber/:orderTotal/:itemId?',
        name: 'CCAction',
        component: () => import(/* webpackChunkName: "craneMain" */ '@/routes/crane/cc_action.vue'),
        meta: {
            breadcrumb: {
                label: 'CC Action',
            },
        },
    },
    {
        path: 'cc-update/:ccid/:mode/:quantity/:itemNumber/:itemId/:orderTotal?',
        name: 'CCUpdate',
        component: () => import(/* webpackChunkName: "craneMain" */ '@/routes/crane/cc_update.vue'),
        meta: {
            breadcrumb: {
                label: 'CC Update',
            },
        },
    },
    {
        path: 'cc-cancel/:mode/:itemId/:ccid?/:itemNumber?',
        name: 'CCCancel',
        component: () => import(/* webpackChunkName: "craneMain" */ '@/routes/crane/cc_cancel.vue'),
        meta: {
            breadcrumb: {
                label: 'CC Cancel',
            },
        },
    },
    {
        path: 'cc-error',
        name: 'CCError',
        component: () => import(/* webpackChunkName: "craneMain" */ '@/routes/crane/cc_error.vue'),
        meta: {
            breadcrumb: {
                label: 'CC Error',
            },
        },
    },

    {
        path: 'order-success/:orderId',
        name: 'OrderSuccess',
        component: () =>
            import(/* webpackChunkName: "craneMain" */ '@/routes/crane/order_success.vue'),
        meta: {
            breadcrumb: {
                label: 'Order Success',
            },
        },
    },
    {
        path: 'maintenance/:disableId?',
        name: 'Maintenance-New',
        component: () =>
            import(/* webpackChunkName: "craneMain" */ '@/routes/crane/maintenance.vue'),
        meta: {
            canonical: true,
            breadcrumb: {
                label: 'Maintenance',
            },
        },
    },
    {
        path: 'cart-products',
        name: 'CartProducts',
        component: () =>
            import(/* webpackChunkName: "craneMain" */ '@/routes/crane/cart_products.vue'),
        meta: {
            canonical: true,
            breadcrumb: {
                label: 'cart products',
            },
        },
    },
    {
        path: 'playground',
        name: 'Playground',
        component: () =>
            import(/* webpackChunkName: "craneMain" */ '@/routes/crane/playground.vue'),
        meta: {
            breadcrumb: {
                label: 'Playground Page',
            },
        },
    },

    {
        path: 'shipping/tracking/popup',
        name: 'PopupRedirect',
        component: () =>
            import(/* webpackChunkName: "craneMain" */ '@/routes/crane/popupRedirect.vue'),
        meta: {
            canonical: true,
            breadcrumb: {
                label: 'Popup Redirect',
            },
        },
    },
    {
        path: 'customer/account/createPassword',
        name: 'Create Password',
        component: () =>
            import(/* webpackChunkName: "craneMain" */ '@/routes/crane/customerCreatePassword.vue'),
        meta: {
            breadcrumb: {
                label: 'Create Password',
            },
        },
    },

    {
        path: 'preference-center',
        name: 'PreferenceCenterPage',
        component: () =>
            import(/* webpackChunkName: "craneMain" */ '@/routes/crane/preference_center_page.vue'),
        meta: {
            breadcrumb: {
                label: 'Preference Center Page',
            },
        },
    },
    { path: '/giftcard', redirect: '/me/gift-card-page' },
    { path: '/catalogsearch/result', redirect: '/search' },
    {
        path: 'business-card/:builderSessionId',
        name: 'business-card',
        component: () =>
            import(/* webpackChunkName: "craneMain" */ '@/routes/crane/business_card.vue'),
        meta: {
            canonical: true,
            breadcrumb: {
                label: 'business-card',
            },
        },
    },
    {
        path: 'mlink/:base64Encoding',
        name: 'mlinkPage',
        component: () => import(/* webpackChunkName: "craneMain" */ '@/routes/crane/mlink.vue'),
        meta: {
            breadcrumb: {
                label: 'mlink',
            },
        },
    },
    {
        path: 'build-version',
        name: 'BuildVersion',
        component: () =>
            import(/* webpackChunkName: "craneMain" */ '@/routes/crane/build_version.vue'),
        meta: {
            canonical: true,
            breadcrumb: {
                label: 'Build Version',
            },
        },
    },
    //{
    //path: 'shipping-and-delivery-cms',
    //name: 'ShippingAndDeliveryCms',
    //component: () => import( /* webpackChunkName: "craneMain" */'@/routes/crane/shipping_delivery_cms.vue'),
    //meta: {
    //  "canonical": true,
    // breadcrumb: {
    //    label: 'Shipping and Delivery',
    //},
    // }
    //}
]

let chekoutRoute = {
    path: 'checkout',
    name: 'CheckoutPage',
    component: () =>
        import(/* webpackChunkName: "craneMain" */ '@/routes/crane/checkout_page_authorize.vue'),
    meta: {
        breadcrumb: {
            label: 'checkout',
        },
    },
}
if (useStripePayment == 'true') {
    chekoutRoute = {
        path: 'checkout',
        name: 'CheckoutPage',
        component: () =>
            import(/* webpackChunkName: "craneMain" */ '@/routes/crane/checkout_page.vue'),
        meta: {
            breadcrumb: {
                label: 'checkout',
            },
        },
    }
}

defaultRoutes.push(chekoutRoute)

let shopRoutes = [
    {
        path: '/',
        name: 'ShopPage',
        component: () => import(/* webpackChunkName: "craneMain" */ '@/routes/crane/home_page.vue'),
        meta: {
            canonical: true,
            breadcrumb: {
                label: 'Home',
            },
        },
    },
    // {
    //     path: 'our-papers',
    //     name: 'OurPapers',
    //     component: () => import( /* webpackChunkName: "craneMain" */'@/routes/crane/product_page.vue'),
    //     meta: {
    //         "canonical": true,
    //         breadcrumb: {
    //             label: 'OurPapers',
    //         },
    //     }
    // },
    // {
    //     path: 'product-details/:sku',
    //     name: 'ProductPage',
    //     component: () => import( /* webpackChunkName: "craneMain" */'@/routes/crane/product_page.vue'),
    //     meta: {
    //         breadcrumb: {
    //             label: 'Product Page',
    //         },
    //     }
    // },
    {
        path: '*',
        name: 'RouteNotFound',
        component: () =>
            import(/* webpackChunkName: "craneMain" */ '@/routes/crane/route_not_found.vue'),
    },
]

// Catch-all — must be last child so it only matches when no other
// child route did.  The edge lambda sets <meta property="builderio:page">
// when a Builder.io page exists for the current URI.
// If the meta tag is present → render BuilderioPage inside Layout.
// Otherwise → fall back to SEO rewrites or search redirect.
const catchAllChildRoute = {
    path: ':pathMatch(.*)*',
    name: 'BuilderioPage',
    component: BuilderioPage,
    beforeEnter: (to) => {
        const meta = document.querySelector('meta[property="builderio:page"]')
        if (meta) {
            to.meta.builderioUrlPath = meta.getAttribute('content') || to.path
            return true
        }

        // No Builder.io meta — SEO rewrite or search redirect
        let regEx = new RegExp(`^${to.path}$`)
        let seoData = seoUrls.filter((data) => {
            let url = data.oldUrl
            if (url.charAt(0) !== '/') url = '/' + url
            return url.match(regEx)
        })[0]
        if (seoData) {
            let queryString = Object.keys(to.query)
                .map((key) => key + '=' + to.query[key])
                .join('&')
            location.href = seoData.newUrl + '?' + queryString
        } else {
            let q = to.path.replace('/', '')
            location.href = vueHomePageUrl + '/search?q=' + q
        }
    },
}

let childrenRoutes = seoRoutes.concat(defaultRoutes, [catchAllChildRoute])

export default [
    {
        path: '/',
        name: 'Main',
        component: () =>
            import(/* webpackChunkName: "craneMain" */ '@/components/layout/Layout.vue'),
        children: childrenRoutes,
    },
    {
        path: '/shop',
        name: 'Shop',
        component: () =>
            import(/* webpackChunkName: "craneMain" */ '@/components/layout/Layout.vue'),
        children: shopRoutes,
    },
]
